import {
  Flex,
  VerticalDivider,
  config as cssConfig,
} from "@100mslive/react-ui";
import { LiveStatus, RecordingStatus, StreamActions } from "./StreamActions";
import { Logo, SpeakerTag } from "./HeaderComponents";

import { EmojiReaction } from "../EmojiReaction";
import { LeaveRoom } from "../LeaveRoom";
import MetaActions from "../MetaActions";
import { ParticipantCount } from "./ParticipantList";
import React from "react";
import { useMedia } from "react-use";

export const StreamingHeader = ({ isPreview }) => {
  const isMobile = useMedia(cssConfig.media.md);
  return (
    <Flex
      justify="between"
      align="center"
      css={{ position: "relative", height: "100%", size: "100%" }}
    >
      <Flex
        align="center"
        css={{
          position: "absolute",
          left: "$10",
        }}
      >
        <Logo isPreview={isPreview} />
        {isMobile && (
          <Flex align="center" gap={2}>
            <LeaveRoom />
            <LiveStatus />
            <RecordingStatus />
          </Flex>
        )}
        {/* <VerticalDivider css={{ ml: "$4" }} /> */}
        {/* {!isPreview ? <SpeakerTag /> : null} */}
      </Flex>

      <Flex
        align="center"
        css={{
          position: "absolute",
          right: "$10",
          gap: "$4",
        }}
      >
        {isMobile ? (
          <>
            {/* <EmojiReaction /> */}
            <MetaActions compact />
          </>
        ) : (
          <Flex css={{ gap: "$4" }}>
            <StreamActions />
          </Flex>
        )}
        <ParticipantCount />
      </Flex>
    </Flex>
  );
};
